module.exports = __webpack_public_path__ + "img/e_3_3_r.52da30e3.png";